import React, { useState, useEffect } from 'react'
import * as R from 'ramda'
import { Grid, Typography, DialogTitle, DialogContent } from '@material-ui/core'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import { FormattedMessage } from 'react-intl'
import ResponsiveDialog from 'app/components/dialog/ResponsiveDialog'
import ResponsiveDialogAction from 'app/components/dialog/ResponsiveDialogAction'
import PrimaryButton from 'app/components/buttons/PrimaryButton'
import SecondaryButton from 'app/components/buttons/SecondaryButton'

const useStyles = makeStyles(() => ({
  templateImages: {
    maxWidth: '182px',
    maxHeight: '182px',
    width: '182px',
    height: '182px',
  },
  selectedTemplate: {
    borderColor: 'blue',
    borderWidth: '2px',
  },
  photoframe: {
    display: 'block',
    float: 'left',
    padding: '4px 3px 0px 3px',
    backgroundColor: 'rgb(255, 255, 255)',
    border: '3px solid #07b',
  },
  customWidth: {
    '& .MuiDialog-paperWidthSm': {
      maxWidth: '700px',
      width: '650px',
    },
  },
}))

const VoucherTemplatePicker = (props) => {
  const { voucherTemplateData, onApply, onCancel, isOpen } = props
  const classes = useStyles()
  const [selectedTemplate, setSelectedTemplate] = useState(null)
  const [selectedId, setSelectedId] = useState(null)

  const handleSelect = (template) => {
    setSelectedTemplate(template)
  }

  useEffect(() => {
    if (selectedTemplate) setSelectedId(R.prop('id', selectedTemplate))
  }, [selectedTemplate])

  return (
    <ResponsiveDialog
      isFullScreen={false}
      open={isOpen}
      className={classes.customWidth}
      maxWidth="sm"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle>
        <FormattedMessage id="dealsPromotions.template.picker.dialog.title" />
      </DialogTitle>
      <DialogContent>
        <div>
          {voucherTemplateData &&
            voucherTemplateData.map((group) => (
              <VoucherTemplateGrid
                key={group.name}
                groupName={group.name}
                templates={group.templates}
                classes={classes}
                handleSelect={handleSelect}
                selectedId={selectedId}
              />
            ))}
        </div>
      </DialogContent>
      <ResponsiveDialogAction
        StartButton={
          <SecondaryButton
            className="w-full"
            labelId="dealsPromotions.template.picker.dialog.cancelButton"
            onClick={() => {
              onCancel()
            }}
          />
        }
        EndButton={
          <PrimaryButton
            className="w-full"
            onClick={() => {
              onApply(selectedTemplate)
            }}
            labelId="dealsPromotions.template.picker.dialog.applyButton"
          />
        }
      />
    </ResponsiveDialog>
  )
}

export default VoucherTemplatePicker

const VoucherTemplateGrid = ({
  groupName,
  templates,
  handleSelect,
  selectedId,
}) => {
  const classes = useStyles()
  return (
    <div>
      <Typography className="mx-10 my-12" variant="subtitle1">
        {groupName}
      </Typography>
      <Grid container justify="flex-start" alignItems="center" spacing={2}>
        {templates.map((template) => (
          <Grid item sm={4} xs={6} key={template.id}>
            <div
              className="w-full text-center"
              onClick={() => {
                handleSelect(template)
              }}
            >
              <div
                className={clsx(
                  template.id === selectedId ? classes.photoframe : '',
                )}
              >
                <img
                  alt={template.name}
                  src={template.imageUrl}
                  className="w-full"
                />
              </div>
            </div>
          </Grid>
        ))}
      </Grid>
    </div>
  )
}
